export const CopyCodeListeners = () => {
    const copyButtons = document.querySelectorAll('.copy-btn');

    copyButtons.forEach((btn) => {
        btn.addEventListener('click', (event) => {
            const button = event.target;
            const codeElement = button.nextElementSibling.querySelector('code');
            const codeToCopy = codeElement.innerText;

            navigator.clipboard.writeText(codeToCopy).then(() => {
                button.textContent = 'Copied!';
                button.style.backgroundColor = '#4CAF50';
                setTimeout(() => {
                    button.textContent = 'Copy';
                    button.style.backgroundColor = '';
                }, 2000);
            }).catch(err => {
                console.error('Failed to copy: ', err);
            });
        });
    });
};
